import { $win, $doc, keys, manualUpdate, getDuplicateIds, updateIds } from './utils';
import { eqRows, initManualFormat } from './bm-utils';
import moment from 'moment';
import Pikaday from 'pikaday';

const $bm = $('.bm');
const format = 'MM/DD/YYYY';
const formatText = 'ddd, MMM D';

moment.locale($('html').attr('lang'));

const initDatepickers = () => {
	const $datepickers = $('.js-bm-datepickers');

	$datepickers.each((index, el) => {
		const $el = $(el);
		const container = el.querySelector('.js-bm-datepicker-container');
		const fieldStart = el.querySelector('.js-bm-start');
		const fieldEnd = el.querySelector('.js-bm-end');
		const startText = document.querySelectorAll('.js-bm-text-start');
		const endText = document.querySelectorAll('.js-bm-text-end');
		let minDate = new Date();

		let startDate, endDate;

		if ($el.data('start-date')) {
			const tempoDate = new Date($el.data('start-date'));
			if (tempoDate.getTime() > minDate.getTime()) {
				minDate = new Date($el.data('start-date'));
			}
		}

		const today = moment(minDate).format(format);
		const tomorrow = moment(today).add('1', 'day')._d;

		$(fieldStart).val(today);
		$(fieldEnd).val(tomorrow);

		// Select whole input text on click
		$(fieldStart).add(fieldEnd).on('click', function() {
			this.setSelectionRange(0, this.value.length);
		});

		startText.forEach(el => {
			$(el).text(moment(today).format(formatText));
		})
		endText.forEach(el => {
			$(el).text(moment(today).format(formatText));
		})

		const options = {
			minDate: minDate,
			container,
			keyboardInput: false,
			bound: false,
			format,
			numberOfMonths: 2,
			theme: 'pikaday-bm',
			i18n: {
				months        : moment.months(),
				weekdays      : moment.weekdays(),
				weekdaysShort : moment.weekdaysShort()
			}
		}

		const updateStartDate = () => {
			startPicker.setStartRange(startDate);
			endPicker.setStartRange(startDate);
			endDate = moment(startDate).add('1','day')._d;
			endPicker.setMinDate(endDate);
			endPicker.setDate(endDate);
			startPicker.setEndRange(endDate);

			startPicker.hide();
			endPicker.show();
		}

		const updateEndDate = () => {
			startPicker.setEndRange(endDate);
			endPicker.setEndRange(endDate);

			endPicker.hide();
			startPicker.show();
		}

		const startPicker = new Pikaday({
			field: fieldStart,
			...options,
			onSelect: function() {
				startDate = this.getDate();
				updateStartDate();
				$(startText).text(moment(startDate).format(formatText));

				setTimeout(function() {
					const nextDate = moment(startDate).add(1, 'days');
					const selectedMonth = nextDate.month();
					const selectedYear = nextDate.year();

					$(fieldEnd).val(nextDate.format(format));

					const date = moment(startDate).add(1, 'days');
					let currentMonth = nextDate.month();
					let currentYear = nextDate.year();

					if ( startPicker.calendars[1].month == currentMonth ) {
						currentMonth = startPicker.calendars[0].month;
						currentYear = startPicker.calendars[0].year;
					}

					endPicker.gotoMonth(currentMonth);
					endPicker.gotoYear(currentYear);

					$(fieldEnd).focus();
				}, 10);
			},
			onDraw: function() {
				eqRows(container);

				const duplicatesArray = getDuplicateIds(container);

				for (let i = 0; i < duplicatesArray.length; i++) {
					updateIds(duplicatesArray[i]);
				}

				$(container).find('.pika-select-month').attr('aria-label', 'Select Month')
				$(container).find('.pika-select-year').attr('aria-label', 'Select Year')
			}
		});

		const endPicker = new Pikaday({
			field: fieldEnd,
			...options,
			onSelect: function() {
				endDate = this.getDate();
				updateEndDate();
				$(endText).text(moment(endDate).format(formatText));
			},
			onDraw: function() {
				eqRows(container);
			}
		});

		const _startDate = startPicker.getDate();
		const _endDate = endPicker.getDate();

		if (_startDate) {
			startDate = _startDate;
			updateStartDate();
		}
		if (_endDate) {
			endDate = _endDate;
			// updateEndDate();
		}

		$(fieldStart).on('focusout', function() {
			$(this).val($(this).val().split(' ').join(''));
			updateStartDate();
		});

		$(fieldEnd).on('focusout', function() {
			$(this).val($(this).val().split(' ').join(''));
			updateEndDate();
		});

		$(fieldStart).on('keyup', e => {
			if (e.keyCode === keys.enter) {
				updateStartDate();
			}
		});

		$(fieldEnd).on('keyup', e => {
			if (e.keyCode === keys.enter) {
				updateEndDate();
			}
		});

		$(fieldStart).on('change', function() {
			if ( manualUpdate ) {
				startDate = moment($(this).val(), format).set({year: moment().format('YYYY')})._d;
				updateStartDate();

				const nextDate = moment(startDate, format).add(1, 'days');
				const selectedMonth = nextDate.month();
				const selectedYear = nextDate.year();

				endPicker.setEndRange(nextDate._d);

				endPicker.gotoMonth(selectedMonth);
				endPicker.gotoYear(selectedYear);
			}
		});

		$(fieldEnd).on('change', function() {
			if ( manualUpdate ) {
				const val = $(this).val();

				endDate = moment(val, format).set({year: moment(val, format).format('YYYY')})._d;
				updateEndDate();
			}
		});

		$('.modal-bm').on('show.bs.modal', e => {
			endPicker.hide();
			startPicker.show();
		});

		initManualFormat(fieldStart);
		initManualFormat(fieldEnd);
	});
}

const handleRoomsBM = () => {
	if ($('html[data-template="room-detail"]').length && localStorage.guests) {
		const guests = JSON.parse(localStorage.getItem('guests'));

		if (Object.keys(guests).length) {
			for (let [key, value] of Object.entries(guests)) {
				$(`.modal-bm .js-qty-field[name="${key}"]`).val(value).trigger('change');
			}
		}
	}
}

const handleCounts = () => {
	$('.js-check-count').each(function() {
		const $this = $(this);
		const single = $this.data('single');
		const multi = $this.data('multi');
		const $target = $($this.data('target'));
		const number = Number($this.text());

		if ( number == 1 ) {
			$target.text(single);
		} else {
			$target.text(multi);
		}
	});
};

const handleTextFields = (selector) => {
	$doc.on('change', selector, function() {
		const $this = $(this);
		const $target = $($this.data('target'));

		$target.text($this.val());

		handleCounts();
	});
}

const handleTextFieldsPromo = () => {
	$doc.on('change', '.js-bm-promo', function() {
		const $this = $(this);
		const $target = $($this.data('target'));
		let isFilled = false;

		$('.js-bm-promo').each(function() {
			const val = $(this).val();

			if ( val != '' && !isFilled ) {
				$target.text(val);

				isFilled = true;
			}
		})

		if ( !isFilled ) {
			$target.text($target.data('original'));
		}
	});

	$('.promo-bm input').on('keydown', function(event) {
		if (event.keyCode == 13) {
			event.preventDefault();

			const $modal = $(this).closest('.modal-bm');

			$modal.modal('hide');
		}
	});
}

const handleActiveStates = () => {
	const $modals = $('.modal-bm');
	const triggerString = '.bm__group';
	const activeClass = 'active';

	$modals.on('hide.bs.modal', (e) => {
		$(triggerString).removeClass(activeClass);

		// Remove active class from opened navigations (destination modal second level nav)
		$(e.currentTarget).find('.active').removeClass('active');
	});

	$modals.on('show.bs.modal', e => {
		if ($win.scrollTop() > $(e.currentTarget).offset().top) {
			$('html,body').animate({
				scrollTop: $(e.currentTarget).offset().top
			}, 300);
		}

		$(e.currentTarget).siblings($modals).modal('hide');

		$(e.relatedTarget).parent().siblings().find(triggerString).removeClass(activeClass);
	});

	$modals.on('shown.bs.modal', e => {
		$(e.relatedTarget).addClass(activeClass);
	});
}

const handleDestinationsDropdownAnimation = () => {
	const $containers = $('.destinations-bm');

	$containers.each((i, container) => {
		const $container = $(container);
		const height = $container.outerHeight();
		const $triggers = $container.find('.js-destinations-dropdown-trigger');
		const $back = $container.find('.js-destinations-dropdown-back');

		$container.css({height});

		$triggers.on('click', function(e) {
			e.preventDefault();

			const $dropdown = $(this).next();
			const dropdownHeight = $dropdown.outerHeight();

			$container.css({
				height: dropdownHeight
			})

			$dropdown.addClass('active');
			$container.addClass('dropdown-opened');
		});

		$back.on('click', function (e) {
			$(this).closest('.destinations-bm__dropdown').removeClass('active');

			$container.removeClass('dropdown-opened');
			$container.css({height});
		});

		$container.closest('.modal-bm').on('hide.bs.modal', (e) => {
			$container.css({height});
			$container.removeClass('dropdown-opened');
		})
	});
}

export default function bmUI() {
	initDatepickers();

	handleTextFields('.js-qty-field');
	handleTextFieldsPromo();

	handleActiveStates();

	handleRoomsBM();

	// $win.on('load', function() {
		handleDestinationsDropdownAnimation();
	// });

	handleCounts();

	/* Error to show if no hotel selected in BM */
	$('.js-booking-form').on('BM_HOTEL_NOT_SELECTED', function(){
		$('.bm').addClass('bm--error');
	});

	/* Remove error when hotel is selected in BO */
	$('.js-booking-form').on('BM_HOTEL_SELECTED', function(){
		$('.bm').removeClass('bm--error');
	});
}
